export function getChargeName(name) {
  return name || '[Misc charge]'
}
